import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from './plugins/axios';
import { abilitiesPlugin } from '@casl/vue';
import { Ability } from '@casl/ability';
import registerBaseComponents from './plugins/base';
import './styles/globals.css';
import './styles/typography.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

const app = createApp(App);

import store from './store';
app.use(store);

import vuetify from './plugins/vuetify';
app.use(vuetify);

// vuetify-confirm replacement (custom script)
import ConfirmPlugin from './plugins/confirm';
app.use(ConfirmPlugin);

import moment from 'moment';
moment.locale('nl');
app.config.globalProperties.moment = moment;

import lodash from 'lodash';
app.config.globalProperties.$lodash = lodash;

import BaseField from './components/commonComponents/BaseField';
app.component('base-field', BaseField);

registerBaseComponents(app);

import vueDebounce from 'vue-debounce';
app.directive('debounce', vueDebounce({ lock: true }));

import icons from './plugins/icons';
app.config.globalProperties.$icons = icons;

import primitive_colors from './plugins/primitive_colors';
app.config.globalProperties.$primitive_colors = primitive_colors;

import createEntity from './entity';
app.config.globalProperties.$createEntity = createEntity;

import { VueMaskDirective } from 'v-mask';
const vMaskV2 = VueMaskDirective;
const vMaskV3 = {
    beforeMount: vMaskV2.bind,
    updated: vMaskV2.componentUpdated,
    unmounted: vMaskV2.unbind
};
app.directive('mask', vMaskV3);

app.config.productionTip = false;

app.config.globalProperties.$http = axios;
const accessToken = 'Bearer ' + store.getters.token;

if (accessToken) {
    app.config.globalProperties.$http.defaults.headers.common['Authorization'] = accessToken;
}

app.config.globalProperties.$http.interceptors.response.use(null, error => {
    if (error.response && error.response.status === 401 && store.getters.isLoggedIn) {
        store.dispatch('logout');
    }
    return Promise.reject(error);
});

const ability = new Ability([]);
app.config.globalProperties.ability = ability;
app.use(abilitiesPlugin, ability);
app.provide('ability', ability);
app.config.globalProperties.$axios = axios;

import { Can } from '@casl/vue';

app.use(router);

app.config.globalProperties.$http.interceptors.response.use(null, error => {
    if (error.response && error.response.status === 403 && store.getters.isLoggedIn) {
        router.push('/403')
    }

    return Promise.reject(error);
});

app.config.globalProperties.$http.interceptors.response.use(null, error => {
    if (error.response && error.response.status === 401 && store.getters.isLoggedIn) {
        router.push('/login');
    }

    return Promise.reject(error);
});

import Vue3Toastify, { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
app.use(Vue3Toastify, {
    "theme": "colored",
    "position": "bottom-right",
    autoClose: 2000,
    "dangerouslyHTMLString": true
});
app.config.globalProperties.$toast = toast;

import JsonExcel from "vue-json-excel3";
app.component('downloadExcel', JsonExcel);

import Clipboard from 'v-clipboard';
app.use(Clipboard);

app.component('can', Can);

app.mount('#app');